(function () {
  "use strict";

  function formatMoney(cents, format) {
    if (!format) {
      return "€ " + (cents / 100).toFixed(2).replace(".", ",");
    }
    if (
      window.theme &&
      window.theme.Currency &&
      window.theme.Currency.formatMoney
    ) {
      return window.theme.Currency.formatMoney(cents, format);
    }
    return "€ " + (cents / 100).toFixed(2).replace(".", ",");
  }

  function getMoneyFormat() {
    if (
      window.theme &&
      window.theme.settings &&
      window.theme.settings.moneyFormat
    ) {
      return window.theme.settings.moneyFormat;
    }
    return null;
  }

  function getCouponDiscountCents() {
    const messageContainer = document.querySelector(
      ".docapp-coupon-input--message-container.docapp-alert-success"
    );
    if (!messageContainer) return 0;

    const moneyEl =
      messageContainer.querySelector("[data-geolizr-price]") ||
      messageContainer.querySelector("[data-amount]") ||
      messageContainer.querySelector(".money");

    if (!moneyEl) return 0;

    const geolizrPrice = moneyEl.getAttribute("data-geolizr-price");
    if (geolizrPrice) {
      const cents = parseInt(geolizrPrice, 10);
      return Number.isFinite(cents) ? cents : 0;
    }

    const amountAttr = moneyEl.getAttribute("data-amount");
    if (amountAttr) {
      const amount = parseFloat(amountAttr);
      return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    }

    const txt = (moneyEl.textContent || "")
      .replace(/\s/g, "")
      .replace(/[^\d,.-]/g, "")
      .replace(",", ".");
    const val = parseFloat(txt);
    return Number.isFinite(val) ? Math.round(val * 100) : 0;
  }

  function calculateCartTotals(cart) {
    let compareTotal = 0;
    let finalTotal = cart.total_price || 0;

    const productsContainer = document.querySelector("[data-products]");
    if (!productsContainer) {
      const cartDrawer = document.getElementById("HeaderCart");
      if (!cartDrawer) {
        return {
          finalTotal,
          compareTotal: finalTotal,
          savings: 0,
          percentage: 0,
          couponDiscount: 0,
        };
      }
    }

    const cartItems = document.querySelectorAll(".cart__item");
    let hasComparePrices = false;

    const domItemsMap = new Map();
    cartItems.forEach((itemEl) => {
      const itemKey = itemEl.getAttribute("data-key");
      if (itemKey) domItemsMap.set(itemKey, itemEl);
    });

    if (cart.items && Array.isArray(cart.items)) {
      cart.items.forEach((cartItem) => {
        const domItem = domItemsMap.get(cartItem.key);
        let itemCompareTotal = 0;

        if (domItem) {
          const comparePriceEl = domItem.querySelector(
            ".ck-cart__price-compare"
          );
          if (comparePriceEl) {
            const comparePriceStr =
              comparePriceEl.getAttribute("data-compareprice");
            if (comparePriceStr) {
              const unitCompare = parseInt(comparePriceStr, 10) || 0;
              if (unitCompare > 0) {
                hasComparePrices = true;
                itemCompareTotal = unitCompare * cartItem.quantity;
              }
            }
          }
        }

        if (itemCompareTotal === 0) {
          const unitFinal = cartItem.final_price || cartItem.price || 0;
          itemCompareTotal = unitFinal * cartItem.quantity;
        }

        compareTotal += itemCompareTotal;
      });
    } else {
      cartItems.forEach((itemEl) => {
        const comparePriceEl = itemEl.querySelector(".ck-cart__price-compare");

        if (comparePriceEl) {
          const comparePriceStr =
            comparePriceEl.getAttribute("data-compareprice");
          if (comparePriceStr) {
            const unitCompare = parseInt(comparePriceStr, 10) || 0;
            if (unitCompare > 0) {
              hasComparePrices = true;
              const quantityInput = itemEl.querySelector(".js-qty__num");
              const quantity = quantityInput
                ? parseInt(quantityInput.value, 10) || 0
                : 0;
              compareTotal += unitCompare * quantity;
            }
          }
        } else {
          const priceEl = itemEl.querySelector(".cart__price[data-price]");
          if (priceEl) {
            const unitPrice =
              parseInt(priceEl.getAttribute("data-price"), 10) || 0;
            const quantityInput = itemEl.querySelector(".js-qty__num");
            const quantity = quantityInput
              ? parseInt(quantityInput.value, 10) || 0
              : 0;
            compareTotal += unitPrice * quantity;
          }
        }
      });
    }

    if (!hasComparePrices && compareTotal === 0) {
      compareTotal = finalTotal;
    }

    const couponDiscount = getCouponDiscountCents();
    const discountedFinalTotal = Math.max(0, finalTotal - couponDiscount);

    const savings =
      compareTotal > discountedFinalTotal
        ? compareTotal - discountedFinalTotal
        : 0;

    const percentage =
      savings > 0 && compareTotal > 0
        ? Math.ceil((savings / compareTotal) * 100)
        : 0;

    return {
      finalTotal: discountedFinalTotal,
      compareTotal,
      savings,
      percentage,
      couponDiscount,
    };
  }

  let lastCart = null;

  function updateSubtotals(cart) {
    const subtotalEl = document.querySelector("[data-subtotal]");
    if (!subtotalEl) return;

    const totals = calculateCartTotals(cart);
    const moneyFormat = getMoneyFormat();

    subtotalEl.textContent = formatMoney(totals.finalTotal, moneyFormat);
  }

  function updateFinalAndComparePrices(cart) {
    const totals = calculateCartTotals(cart);
    const finalEl = document.getElementById("mein-benutzerdefinierter-preis");
    const compareEl = document.getElementById("ck-compare-total");
    const badgeEl = document.querySelector(".ck-cart__badge");
    const moneyFormat = getMoneyFormat();

    if (finalEl) {
      finalEl.textContent = formatMoney(totals.finalTotal, moneyFormat);
    }

    if (totals.savings > 0 && totals.compareTotal > totals.finalTotal) {
      if (compareEl) {
        compareEl.textContent = formatMoney(totals.compareTotal, moneyFormat);
        compareEl.style.display = "";
      }

      if (badgeEl) {
        let label = badgeEl.textContent.trim();
        const words = label.split(/\s+/);
        label = words.length > 0 ? words[0] : "Spare";
        badgeEl.textContent = label + " " + totals.percentage + "%";
        badgeEl.style.display = "";
      }
    } else {
      if (compareEl) compareEl.style.display = "none";
      if (badgeEl) badgeEl.style.display = "none";
    }
  }

  function updateFreeShippingText(cart) {
    const shippingEl = document.querySelector(".ck-cart-shipping-price");
    if (!shippingEl) return;

    const threshold = Number(shippingEl.dataset.threshold || 0);
    const freeText = shippingEl.dataset.freeText || "Gratuit";
    const shippingPrice = shippingEl.dataset.shippingPrice || "0";

    const totals = calculateCartTotals(cart);

    if (threshold && totals.finalTotal >= threshold) {
      shippingEl.textContent = freeText;
      shippingEl.classList.add("ck-free-shipping");
    } else {
      shippingEl.textContent = shippingPrice + " €";
      shippingEl.classList.remove("ck-free-shipping");
    }
  }

  function updateCartDrawer(cart) {
    if (!cart) return;

    updateSubtotals(cart);
    updateFinalAndComparePrices(cart);
    updateFreeShippingText(cart);
  }

  function fetchCartData() {
    return fetch("/cart.js")
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch cart data");
        return response.json();
      })
      .catch((error) => {
        console.error("Error fetching cart data:", error);
        return null;
      });
  }

  function handleCartUpdate() {
    setTimeout(() => {
      fetchCartData().then((cart) => {
        if (!cart) return;

        lastCart = cart;

        let attempts = 0;
        const maxAttempts = 15;

        const checkAndUpdate = () => {
          const cartItems = document.querySelectorAll(".cart__item");
          const productsContainer = document.querySelector("[data-products]");

          const itemsMatch =
            cartItems.length === cart.item_count ||
            (cartItems.length > 0 && cart.item_count > 0);

          if (itemsMatch || (productsContainer && cart.item_count === 0)) {
            updateCartDrawer(cart);
          } else if (attempts < maxAttempts) {
            attempts++;
            setTimeout(checkAndUpdate, 150);
          } else {
            updateCartDrawer(cart);
          }
        };

        checkAndUpdate();
      });
    }, 600);
  }

  function recalcPricesOnly() {
    if (!lastCart) return;
    updateCartDrawer(lastCart);
  }

  function updateCartScrollableMinHeight() {
    requestAnimationFrame(function () {
      setTimeout(function () {
        const cartScrollable = document.querySelector(".cart__scrollable");
        const cartHeader = document.querySelector(".cart__header");
        const cartFooter = document.querySelector(".cart__footer");

        if (!cartScrollable) {
          console.warn("⚠️ cartScrollable not found!");
          return;
        }

        let footerHeight = 0;
        let headerHeight = 0;

        if (cartHeader) {
          headerHeight =
            cartHeader.offsetHeight ||
            cartHeader.getBoundingClientRect().height ||
            0;
        }

        if (cartFooter) {
          footerHeight = cartFooter.offsetHeight || 350;
          if (footerHeight === 0) {
            const rect = cartFooter.getBoundingClientRect();
            footerHeight = Math.abs(rect.height) || 350;
          }
          if (footerHeight <= 0 || isNaN(footerHeight)) footerHeight = 350;
        }

        const newMinHeight = `calc(100dvh - ${footerHeight}px - ${headerHeight}px)`;
        cartScrollable.style.minHeight = newMinHeight;
      }, 100);
    });
  }

  function init() {
    document.addEventListener("cart:build", handleCartUpdate);
    document.addEventListener("ajaxProduct:added", handleCartUpdate);
    document.addEventListener("cart:updated", handleCartUpdate);

    document.addEventListener("click", function (e) {
      if (e.target.closest(".js-qty__adjust")) {
        handleCartUpdate();
      }

      const discountButton =
        e.target.closest(".docapp-coupon-input--button-text") ||
        e.target.closest(".docapp-coupon-input--button") ||
        e.target.closest("[class*='docapp-coupon']");

      if (discountButton) {
        setTimeout(recalcPricesOnly, 200);
        setTimeout(recalcPricesOnly, 800);
        setTimeout(updateCartScrollableMinHeight, 300);
      }

      if (
        e.target.closest(".docapp-coupon-input--bean-container--bean-remove")
      ) {
        setTimeout(recalcPricesOnly, 150);
        setTimeout(recalcPricesOnly, 600);
      }
    });

    const cartDrawer = document.getElementById("HeaderCart");
    if (cartDrawer) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "class") {
            const classList = mutation.target.classList;
            if (classList.contains("is-active")) {
              handleCartUpdate();
              setTimeout(updateCartScrollableMinHeight, 800);
            }
          }
        });
      });

      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    const cartFooter = document.querySelector(".cart__footer");
    if (cartFooter) {
      const footerObserver = new MutationObserver((mutations) => {
        let shouldUpdateHeight = false;

        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((node) => {
              if (
                node.nodeType === 1 &&
                (node.classList?.contains(
                  "docapp-coupon-input--message-container"
                ) ||
                  node.querySelector?.(
                    ".docapp-coupon-input--message-container"
                  ))
              ) {
                shouldUpdateHeight = true;
                setTimeout(recalcPricesOnly, 120);
              }
            });

            mutation.removedNodes.forEach((node) => {
              if (
                node.nodeType === 1 &&
                (node.classList?.contains(
                  "docapp-coupon-input--message-container"
                ) ||
                  node.querySelector?.(
                    ".docapp-coupon-input--message-container"
                  ))
              ) {
                shouldUpdateHeight = true;
                setTimeout(recalcPricesOnly, 120);
              }
            });
          }

          if (
            mutation.type === "attributes" &&
            (mutation.attributeName === "style" ||
              mutation.attributeName === "class")
          ) {
            const target = mutation.target;
            if (
              target.classList?.contains(
                "docapp-coupon-input--message-container"
              ) ||
              target.closest?.(".docapp-coupon-input--message-container")
            ) {
              shouldUpdateHeight = true;
              setTimeout(recalcPricesOnly, 120);
            }
          }
        });

        if (shouldUpdateHeight) {
          setTimeout(updateCartScrollableMinHeight, 300);
        }
      });

      footerObserver.observe(cartFooter, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    }

    if (cartDrawer && cartDrawer.classList.contains("is-active")) {
      handleCartUpdate();
      setTimeout(updateCartScrollableMinHeight, 800);
    } else {
      setTimeout(updateCartScrollableMinHeight, 500);
      fetchCartData().then((cart) => {
        if (cart) {
          lastCart = cart;
          updateCartDrawer(cart);
        }
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
